'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import { getIsInLegacyLayoutMode, getIsDraggingModule } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import AfterBeginPortal from 'ContentEditorUI/components/portals/AfterBeginPortal';
import ExitLayoutModeButton from 'ContentEditorUI/components/overlays/ExitLayoutModeButton';
import { updateInpageMode as updateInpageModeAction } from 'ContentEditorUI/redux/actions/inpageActions';
import { InpageModes } from 'ContentEditorUI/lib/app/constants';
import { getIframeCaresAboutNextWindowClick } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => {
  return {
    isInLegacyLayoutMode: getIsInLegacyLayoutMode(state),
    iframeCaresAboutNextWindowClick: getIframeCaresAboutNextWindowClick(state),
    isDraggingModule: getIsDraggingModule(state)
  };
};
const mapDispatchToProps = {
  updateInpageMode: updateInpageModeAction
};

/**
 * @param {Object} props
 * @param {boolean} props.isDraggingModule (required)
 * @param {boolean} props.isInLegacyLayoutMode (required)
 * @param {Function} props.updateInpageMode (required)
 */
class ExitLayoutModeButtonContainer extends Component {
  constructor(props) {
    super(props);
    this.onExitLegacyLayoutMode = () => {
      const {
        updateInpageMode
      } = this.props;
      updateInpageMode(InpageModes.DEFAULT);
    };
    this.exitLayoutModeButtonWrapper = document.querySelector('.contentEditor-exitButton');
  }
  render() {
    const {
      isInLegacyLayoutMode,
      isDraggingModule
    } = this.props;
    // Don't actually render the iframe,
    // its already part of the jade template markup and may
    // already be loaded via early iframe code

    if (isDraggingModule || !isInLegacyLayoutMode) {
      return null;
    }
    return /*#__PURE__*/_jsx(AfterBeginPortal, {
      id: "exitLayoutModeBtn",
      targetElement: this.exitLayoutModeButtonWrapper,
      children: /*#__PURE__*/_jsx(ExitLayoutModeButton, {
        onClick: this.onExitLegacyLayoutMode
      })
    });
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ExitLayoutModeButtonContainer);